"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("../../http");
var Message_1 = require("../Message");
var constants_1 = require("../constants");
/**
 *  Bid events are sent when we receive a bid back from a bidder.
 * in:
 *   adUnitId: the id on the div that this ad is going to render in
 *   partnerId: an identifier for who the bid came from. ideally human readable.
 *   price: the price bid for the ad, CPM in cents in USD
 *   dimensions: the size of the ad in the bid. (check this)
 * out:
 *   this function returns a UUID for the event that was sent
 * side effects:
 *   none
 * notes:
 *   this reads adPartner out of the window.ads cache, and uses that to pull the "right"
 *   request id out of the cache for this request. It is theoretically possible that adPartner
 *   could be overwritten by a subsequent request, and this will return the wrong, or potentialy
 *   no requestId at all.
 */
var sendBid = function (adUnitId, partnerId, price, dimensions) {
    // load common data from the adUnitId cache
    var page = window.ads[adUnitId]["page"];
    var storyId = window.ads[adUnitId]["story_id"];
    var partId = window.ads[adUnitId]["part_id"];
    var adPartner = window.ads[adUnitId]["ad_partner"];
    var requestId = window.ads[adUnitId][adPartner + "_request"];
    var message = (0, Message_1.getCommonMessageFields)(page, storyId, partId);
    var requestOffset = Date.now() - window.ads[adUnitId][constants_1.startTimeField];
    // bid specific fields
    message.ad_partner = adPartner;
    message.page_view_id = window.ads.page_view_id;
    message.adunit_id = adUnitId;
    message.partner_id = partnerId;
    message.price = price;
    message.dimensions = dimensions;
    message.request_id = requestId;
    message.request_offset = requestOffset;
    // there is a response_id field in the bid table, but it doesn't really make any sense.
    // These bids are the responses from the "request"
    (0, http_1.sendAthaEvent)("bid", message);
    return message["id"];
};
exports.default = sendBid;
